import React from "react"
import PropTypes from "prop-types"
import styles from "./DataTableItem.module.css"
import { ChevronRight } from "react-feather"
import { Text, Paragraph } from "ui/Typography"
import { Button, Flex } from "antd"

const DataTableItem = ({ data, onClick, extraRows, actionIcon, setOpenActionDrawer, onActionIconClick }) => {
  return (
    <div className={styles.item}>
      <Flex align="center">
        <div className="flex-1">
          {Object.entries(data).map(([label, value]) => {
            if (label === "id") return null
            return (
              <Button type="text" className={`w-full ${styles.row}`} key={label} onClick={onClick}>
                <Text className={styles.label}>{label}</Text>
                <Paragraph
                  className={styles.value}
                  ellipsis={{
                    rows: 2
                  }}
                >
                  {value}
                </Paragraph>
              </Button>
            )
          })}
          {extraRows && (
            <Button type="text" className="justify-between w-full" onClick={onClick}>
              <Text className={styles.label}></Text>
              <Button
                className={styles.value}
                type="text"
                onClick={(e) => {
                  setOpenActionDrawer(true)
                  e.stopPropagation()
                  if (onActionIconClick) onActionIconClick()
                }}
              >
                {extraRows}
              </Button>
            </Button>
          )}
        </div>
        {actionIcon ? (
          <Button
            type="text"
            onClick={(e) => {
              setOpenActionDrawer(true)
              e.stopPropagation()
              if (onActionIconClick) onActionIconClick()
            }}
          >
            {actionIcon}
          </Button>
        ) : (
          <ChevronRight onClick={onClick} className={styles.arrow} />
        )}
      </Flex>
    </div>
  )
}

DataTableItem.propTypes = {
  data: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  onActionIconClick: PropTypes.func,
  extraRows: PropTypes.node,
  actionIcon: PropTypes.node,
  setOpenActionDrawer: PropTypes.func
}

export default DataTableItem
